import { firestore, storage } from "./config";
import { doc, getDoc, setDoc, updateDoc, collection, query, where, getDocs } from "firebase/firestore";
import { ref, getDownloadURL, list } from "firebase/storage";

export const createUserDocument = async (user) => {
  const docRef = doc(firestore, "users", user.uid);
  const docSnap = await getDoc(docRef);

  //Create user object
  const userProfile = {
    uid: user.uid,
    email: user.email,
    name: user.displayName,
    language: "English",
    isAdmin: false,
    canAccessDMS: false,
    canAccessFMS: false,
    photoURL: user.photoURL,
    dms: {
      canAcceptDonation: false,
      canAccess: false,
      canCreateDonor: false,
      canUpdateDonor: false,
      canAccessReports: false,
    },
    ams: {
      isStaff: false,
      isAdmissionAdmin: false,
      isManagement: false,
      isParent: false,
    },
    ems: {
      isExpenseStaff: false,
      isExpenseAuditor: false,
      isExpenseApproverL1: false,
      isExpenseApproverL2: false,
    },
    academic_calendar: {
      isCalendarAdmin: false,
    },
    websiteAccess: {
      canAccessAdmin: false,
      canAccessEvent: false,
      canAccessGallery: false,
      canAccessNews: false,
    },
    g_classroom_dashboard: {
      canAccess: false,
      isAdmin: false,
    },
    studentMaster: {
      canAccess: false,
      canCreate: false,
      canUpdate: false,
    },
    taskRole: "TaskUser",
    status: "Active",
  };

  if (!docSnap.exists()) {
    //write to cloud firesore
    return setDoc(docRef, userProfile);
  } else {
    //Update the existing user profile
    const updateData = {
      uid: user.uid,
      email: user.email,
      name: user.displayName,
      photoURL: user.photoURL,
    };
    const existingData = docSnap.data();
    if (existingData && existingData.taskRole === undefined) {
      updateData.taskRole = "TaskUser";
    }
    if (existingData && existingData.status === undefined) {
      updateData.status = "Active";
    }
    return updateDoc(docRef, updateData);
  }
};

export const getImageUrl = async (path) => {
  return getDownloadURL(ref(storage, path));
};

export const listStorage = async (path) => {
  return list(ref(storage, path));
};

export const uploadFile = async (file) => {};

export const searchUsersByEmail = async (emailPrefix) => {
  const q = query(
    collection(firestore, "users"),
    where("email", ">=", emailPrefix),
    where("email", "<=", emailPrefix + "\uf8ff")
  );
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((doc) => {
    const data = doc.data();
    return {
      userId: doc.id,
      name: data.name || "",
      email: data.email || "",
      status: data.status || "Active",
    };
  });
};

export const getUserById = async (uid) => {
  const docRef = doc(firestore, "users", uid);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data();
  }
  return null;
};

export const updateUserById = async (uid, data) => {
  const docRef = doc(firestore, "users", uid);
  return updateDoc(docRef, data);
};

